import { getElementOrLogError } from '../../utils/utils';
export class Card {
    constructor(template, actions) {
        var _a;
        this.template = template;
        this.actions = actions;
        this._colors = {
            "дополнительное": "additional",
            "софт-скил": "soft",
            "кнопка": "button",
            "хард-скил": "hard",
            "другое": "other",
        };
        this._cardElement = null;
        this._categoryElement = null;
        this._titleElement = null;
        this._imageElement = null;
        this._priceElement = null;
        this._cardElement = getElementOrLogError('.card', this.template.content).cloneNode(true);
        this._categoryElement = getElementOrLogError('.card__category', this._cardElement);
        this._titleElement = getElementOrLogError('.card__title', this._cardElement);
        this._imageElement = getElementOrLogError('.card__image', this._cardElement);
        this._priceElement = getElementOrLogError('.card__price', this._cardElement);
        if ((_a = this.actions) === null || _a === void 0 ? void 0 : _a.onClick) {
            this._cardElement.addEventListener('click', this.actions.onClick);
        }
    }
    setTextContent(element, value) {
        if (element) {
            element.textContent = String(value);
        }
    }
    setPrice(value) {
        return value === null ? 'Бесценно' : `${value} синапсов`;
    }
    updateCategoryElement(category) {
        if (this._categoryElement) {
            this.setTextContent(this._categoryElement, category);
            this._categoryElement.className = `card__category card__category_${this._colors[category] || 'default'}`;
        }
    }
    updateCardElements(data) {
        this.updateCategoryElement(data.category);
        this.setTextContent(this._titleElement, data.title);
        if (this._imageElement) {
            this._imageElement.src = data.image;
            this._imageElement.alt = data.title;
        }
        this.setTextContent(this._priceElement, this.setPrice(data.price));
    }
    render(data) {
        this.updateCardElements(data);
        return this._cardElement;
    }
}
